import { useEffect } from 'react';

import usePrepareDisclosuresWizard from './usePrepareDisclosuresWizard';

const useRegisterStepGate = (step, canContinue) => {
  const { registerStepGate } = usePrepareDisclosuresWizard();

  useEffect(() => {
    registerStepGate(step, canContinue);
  }, [registerStepGate, step, canContinue]);
};

export default useRegisterStepGate;
